import { useQuery } from "@tanstack/react-query";
import { getJackpotList } from "../../../api/getApi";

const useJackpotQueries = () => {
  const { data, isFetching } = useQuery({
    queryKey: ["jackpotData"],
    queryFn: async () => await getJackpotList(),
    select: (data) => data.data.jackpots,
  });

  return {
    jackpotList: data,
    isLoading: isFetching,
  };
};

export default useJackpotQueries;
